module.exports = __webpack_public_path__ + "static/media/HomePic3.2311250a.jpg";